<template>
   <div>
    <div>
        <div class="clearfix table-tools">
        <div class="search">
            <a-form layout='inline' @submit="searchList">
            <a-form-item>
                <a-radio-group :value="paramsData.search.shsz">
                    <a-radio-button value="sh" @click="handleButChange('sh')">
                    主板
                    </a-radio-button>
                    <a-radio-button value="sz" @click="handleButChange('sz')">
                    创业
                    </a-radio-button>
                </a-radio-group>


                <a-radio-group :value="paramsData.search.stock_zhangting_type">
                    <a-radio-button value="1" @click="handleBut2Change('1')">
                    一字板
                    </a-radio-button>
                    <a-radio-button value="0" @click="handleBut2Change('0')">
                    换手板
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>
            <a-form-item>
                <a-tooltip placement="topLeft" >
                    <template slot="title">
                    <span>股票代码</span>
                    </template>
                    <a-input v-model.trim="paramsData.search.stock_code" allowClear placeholder="股票代码" style="width: 180px"/>
                </a-tooltip>
            </a-form-item>
            <a-form-item>
                <a-tooltip placement="topLeft" >
                    <template slot="title">
                    <span>涨停原因</span>
                    </template>
                    <a-input v-model.trim="paramsData.search.stock_reason" allowClear placeholder="涨停原因" style="width: 180px"/>
                </a-tooltip>
            </a-form-item>
            <a-form-item>
                <a-tooltip placement="topLeft" >
                <template slot="title">
                    <span>时间筛选</span>
                </template>
                <a-range-picker
                    :ranges="rangesData"
                    :value='rangesValue'
                    :disabled-date="disabledDate" :allowClear="false"
                    :default-value="[moment(paramsData.search.start_date,'YYYY-MM-DD'),moment(paramsData.search.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                    @change="(date, dateString)=>onChange(date, dateString,1)" />
                </a-tooltip>
            </a-form-item>


            <!-- <a-form-item>
                <a-radio-group :value="paramsData.search.stock_status" @change="handleButChange">
                    <a-radio-button value="0">
                    历史
                    </a-radio-button>
                    <a-radio-button value="1">
                    最终
                    </a-radio-button>
                </a-radio-group>
            </a-form-item> -->

            <a-form-item>
                <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
            </a-form-item>

            <hr/>
            <a-tag v-for="(item,index) in yesterday_kick_resason_list" @click="clkzt(item.stock_reason)">{{item.stock_reason}} # {{item.total}}</a-tag>

            <hr/>
            <a-tag v-for="(item,index) in kick_resason_list" :color="item.color" @click="clkzt(item.stock_reason)">{{item.stock_reason}} # {{item.total}}</a-tag>
            </a-form>
        </div>
        </div>
        <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>


        <ve-histogram 
            :data="kickChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            height="300px"
            :title="{
                text:`kick chart`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['主板','创业'],
                axisSite: { right: ['创业'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

        <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
            :columns="columns" :dataSource="list" @change="handleChange">
            <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1)}}</span>
            </template>
            <template #bodyCell="{ text }">
                <div class="cell-content">
                    {{ text }}
                </div>
            </template>
            <template slot="stock_zhangting_shijian" slot-scope="text, record , index">
                <span @click="clktime(record.stock_code,record)">{{text}}</span>
            </template>

            <template slot="stock_name" slot-scope="text, record , index">
                <div v-clipboard:copy="record.stock_code" class="cell-content">
                    {{ text }}
                </div>
                <!-- <a-tag color="orange" v-for="(tagname,index) in record.tags.T">
                    {{tagname}}
                </a-tag>
                <a-tag color="green" v-for="(tagname,index) in record.tags.S">
                    {{tagname}}
                </a-tag>
                <a-tag color="red" v-for="(tagname,index) in record.tags.B">
                    {{tagname}}
                </a-tag> -->
            </template>

            <template slot="stock_code" slot-scope="text, record , index">
                <span @click="clk(record.stock_code,record)">{{text}}</span>
            </template>

            <template slot="concept_name" slot-scope="text, record , index">
                <span @click="viewConcept(record)">{{text}}</span>
            </template>

            <template slot="stock_bk_name" slot-scope="text, record , index">
                <span @click="clkzt(text)">{{text}}</span><a href="#" style="color:red;">({{record.stock_bk_zhangtingshu}})</a>
            </template>

            <template slot="action" slot-scope="text,record">
                  <a href="javascript:;" @click="view(record)">View</a>
            </template>

            <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
            </template>

            <template slot="stock_zongzhi" slot-scope="text, record , index">
                <span :style="{ color: text > 1e10 ? 'red' : '' }"> {{ (formatNumber(text)) }}</span>
            </template>

            <template slot="stock_bk" slot-scope="text, record , index">
                <!-- <div style="white-space: pre-wrap;" @click="viewConcept(record)">{{text}}</div> -->
                <div style="white-space: pre-wrap;" v-if="!record.reason_type" @click="viewConcept(record)">{{text}}</div>
                <div style="white-space: pre-wrap;" @click="viewConcept(record)">{{record.reason_type}}</div>
            </template>
            
            <template slot="stock_reminder_msg" slot-scope="text, record , index">
                <div style="white-space: pre-wrap;" @click="clk(record.stock_code)">{{text}}</div>
            </template>
        </a-table>
        </div>
        <!-- <div class="page">
            <a-pagination
            :pageSizeOptions="pageSizeOptions"
            :total="pageParams.totalCount"
            showSizeChanger
            :pageSize="pageParams.perPage"
            v-model="current"
            @change="changePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
            >
                <template slot='buildOptionText' slot-scope='props'>
                <span v-if="props.value!=='100'">{{props.value}}条/页</span>
                <span v-if="props.value==='100'">100条/页</span>
                </template>
            </a-pagination>
        </div> -->
    </div>
    <!-- <editModal v-if="editVisible" :item="modalData"/> -->
    <a-modal v-model="editVisible" :title="stock_title" cancelText="取消" okText="刷新" width="1750px" @ok="handleOk" >
        <vue-element-loading :active="loadingP" color="#00cca2" spinner="spinner"/>

        <a-list size="small" bordered :data-source="articles_list" v-if="false">
            <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta :description="item.ctime">
                <a slot="title">【{{ item.fieldName }}】 {{ item.title }}</a>
            </a-list-item-meta>
            </a-list-item>
        </a-list>

        <a-date-picker @change="onFsChange" v-if="false"/>
        <ve-histogram
            :data="predictLiuruChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`资金流入统计`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

            <ve-histogram
            :data="rsiChart" 
            v-if="false"
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:'RSI6 CHART',
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['RSI6'],
            }" 
            :extend="histogramChartExtend" ></ve-histogram>
            
        <ve-histogram 
            v-if="false"
            :data="fs_list_chart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${fs_list_chart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['P','A'],
                axisSite: { right: ['P','A'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>
        <a-row :gutter="[16,8]">
            <a-col :span="2"  v-for="(data,index) in pie" :key="index" @click="clkFs(data)">
                    <ve-pie  
                        judge-width
                        :data="data"
                        :legend="{
                            show:false,
                            type:'scroll',
                            orient: 'vertical',
                            left:'0%',
                            align:'left',
                            top:'middle',
                            textStyle: {
                                color:'#8C8C8C'
                            },
                        }
                        "
                        height="90px" 
                        :title="{
                            text:`${data.title}`,
                            x:'center',
                            y:'bottom',
                            textStyle: {
                                fontSize: 12.5,
                            },
                            subtextStyle: {
                                fontSize: 12.5
                            },
                        }" 
                        :extend="{
                            series:{
                                labelLine: {
                                    show: false, //隐藏指示线
                                },
                                label: {
                                    show: false, //隐藏标示文字
                                },
                                radius: data.radius,
                                center: ['50%', '35%'],
                            }
                        }">
                    </ve-pie>
                </a-col>
            </a-row>
            <ve-histogram 
            v-if="false"
            :data="predictChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${predictChart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['超大','流入','大','成交','类型','涨','占比',],
                axisSite: { right: ['涨'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

            <a-card v-for="(tableData, index) in kick_his_list" v-if="false">
                <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                    :columns="ztcolumns" :dataSource="tableData">
                    <template slot="index" slot-scope="text, record , index">
                    <span>{{(index+1)}}</span>
                    </template>
                    <template slot="price" slot-scope="text, record , index">
                    <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                    </template>
                </a-table>
            </a-card>

            <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                :columns="columns2" :dataSource="liuruList">
                <template slot="index" slot-scope="text, record , index">
                <span>{{(index+1)}}</span>
                </template>
                <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>

            <template>
            <!-- <a-timeline>
                <a-timeline-item :color="msg.color" v-for="(msg,index) in predictMsg" :key="index">{{msg.stock_date}} {{msg.tm}} {{msg.msg}}</a-timeline-item>
            </a-timeline> -->
        </template>
        <LEmpty v-if="first>0 && predictChart.rows.length == 0"/>
    </a-modal>

    <a-modal v-model="dVisible" :title="concept?concept.concept_name+' '+record.stock_zhangting_shijian:record.stock_reason+' '+record.stock_zhangting_shijian"  cancelText="取消" okText="刷新" width="1550px">
          <vue-element-loading :active="dlLoading" color="#00cca2" spinner="spinner"/>
          <ve-histogram 
            v-if="false"
            :data="liuruChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :title="{
                text:`资金流入统计`,
                textStyle: {
                    fontSize: 15,
                },
                susortextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

        <a-radio-group :value="searchData.bk_date" @change="handleButDateChange">
              <a-radio-button :value="data.日期" v-for="data in liuruChart.rows" v-if="data.日期.length < 6">
              {{data.日期}}
              </a-radio-button>
          </a-radio-group>

          <hr />

          <a-radio-group :value="searchData.shsz" @change="handleModalButChange">
              <a-radio-button value="sh">
              主板
              </a-radio-button>
              <a-radio-button value="sz">
              创业
              </a-radio-button>
          </a-radio-group>

          <a-radio-group>
              <a-radio-button value="1" @click="handleButAddChange()">
              +
              </a-radio-button>  
          </a-radio-group>

          <hr/>

          <a-radio-group :value="searchData.bk_stock_type" @change="handleButTypeChange">
              <a-radio-button value="">
              全部
              </a-radio-button>
              <a-radio-button value="small">
                < 30
              </a-radio-button>
              <a-radio-button value="middle">
                < 50
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-radio-group :value="searchData.bk_sort" @change="handleSort">
            <a-radio-button :value="data" :key="idx" v-for="(idx,data) in sort_list">
                {{idx}}
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-table size="small" :pagination="false" :bordered='false' rowKey="code" :columns="columns4" :dataSource="detail_list" @change="handleChange2">
                <template slot="index" slot-scope="text, record , index">
                    <span>{{(index+1)}}</span>
                </template>

                <template slot="price" slot-scope="text, record , index">
                    <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="stock_code" slot-scope="text, record , index">
                  <span @click="clk(record.stock_code,record)">{{text}}</span>
                  <!-- <a-tag color="#f50">
                    中
                  </a-tag> -->
                </template>

                <template slot="opt" slot-scope="text, record , index">
                    <span :style="{ color: text.fs_type == 'B' ? 'red' : 'green' }">{{ (formatNumber(text.fs_total)) }}</span>
                </template>
                
                <template slot="concept_name" slot-scope="text, record , index">
                  <span @click.stop v-clipboard:copy="record.stock_code">{{text}}</span>
                </template>

                <template slot="stock_zongzhi" slot-scope="text, record , index">
                    <span :style="{ color: text > 1e10 ? 'red' : '' }"> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="stock_chengjiaoe" slot-scope="text, record , index">
                    <span> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="fs_low_minute" slot-scope="text, record , index">
                    <span> {{ ((text)) }}</span>
                </template>

                <template slot="fs_one_total" slot-scope="text, record , index">
                    <!-- <span :style="{ color: record.fs_one_total.stock_is_low =='0' ? 'red' : '' }"> {{ ((text.bili)) }}</span> -->
                    <span> {{ ((text.bili)) }}</span>
                </template>

                <template slot="fs_one_total_m" slot-scope="text, record , index">
                    <span> {{ (formatNumber(text.stock_total)) }}</span>
                </template>

                <template slot="stock_name" slot-scope="text, record , index">
                  <a-badge status="success" v-if="record.isHigh" />
                  <!-- <span  @click="addStock(record)">{{text}}</span> -->
                  <span :style="{ color: record.is_red ? 'red' : record.is_green ? 'green':'' }" @click="clk_buy(record.stock_code,record.stock_name)"> {{ (text) }}</span>
                </template>
                <template slot="stock_short_count" slot-scope="text, record , index">
                    <span>{{record.stock_yes_short_count}}/{{record.stock_short_count}}</span>
                </template>
                <template slot="stock_zhangdiefu_zuixin" slot-scope="text, record , index">
                  <span :style="zuixincolor(text,record.stock_zhangdiefu)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>
      </a-modal>

      <a-drawer
      :title="stock_detail.stock_name"
      placement="left"
      @close="onClose"
      :closable="false"
      :visible="drvisible"
    >
    <a-list size="small" bordered :data-source="stock_detail.stock_concept_list">
      <a-list-item slot="renderItem" slot-scope="item, index" @click="clk_concept(item.concept_code,item)">
        {{ item.concept_name }}#{{ item.concept_rate }}
      </a-list-item>
      
    </a-list>
    </a-drawer>

    <a-modal v-model="kickVisible" cancelText="取消" okText="刷新" width="1750px">
        <vue-element-loading :active="kickLoading" color="#00cca2" spinner="spinner"/>
        <div class="table">
        <a-table size="small" :pagination="false" :bordered='false' rowKey="id" :columns="columns3" @change="handleChange" :dataSource="kick_list">
            <template slot="index" slot-scope="text, record , index">
              <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
            </template>
            <template slot="opt_content" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="stock_code" slot-scope="text, record , index">
                <span @click="clk(record.stock_code,record)">{{text}}</span>
            </template>
            <template slot="opt" slot-scope="text, record , index">
                    <span :style="{ color: text.fs_type == 'B' ? 'red' : 'green' }">{{ (formatNumber(text.fs_total)) }}</span>
            </template>
            <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
              </template>
        </a-table>
        </div>
    </a-modal>

    <a-modal v-model="fsVisible" cancelText="取消" okText="刷新" width="1550px">
        <a-row :gutter="[16,16]">
            <a-col :span="4"  v-for="(data,index) in fs_list" :key="index">
                <a-timeline>
                    <a-timeline-item :color="msg.color" v-for="(msg,index) in data" :key="index">{{msg.stock_time}} # {{msg.fs_opt}} # {{formatNumber(msg.fs_total)}} </a-timeline-item>
                </a-timeline>
            </a-col>
        </a-row>
    </a-modal>

  </div>
</template>

<script>

const ztcolumns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '涨停时间',  align:'left', dataIndex: 'stock_zhangting_shijian', key: 'stock_zhangting_shijian',sorter:()=>{}, scopedSlots: { customRender: 'stock_zhangting_shijian' }},
  { title: '股票名称',  align:'left', dataIndex: 'stock_name', key: 'stock_name',sorter:()=>{}},
  { title: '连板',  align:'left', dataIndex: 'kick_no', key: 'kick_no',sorter:()=>{}},
  { title: '股票代码',  align:'left', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '板块名称',  align:'left', dataIndex: 'concept_name', key: 'concept_name',sorter:()=>{}, scopedSlots: { customRender: 'concept_name' }},
  { title: '主力封单',  align:'left', dataIndex: 'stock_fengdan', key: 'stock_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '最大封单',  align:'left', dataIndex: 'stock_max_fengdan', key: 'stock_max_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力净额',  align:'left', dataIndex: 'stock_zhuli_jinge', key: 'stock_zhuli_jinge',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力卖出',  align:'left', dataIndex: 'stock_zhuli_maichu', key: 'stock_zhuli_maichu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力买入',  align:'left', dataIndex: 'stock_zhuli_mairu', key: 'stock_zhuli_mairu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '股票板块', width: 160, align:'left', dataIndex: 'stock_bk', key: 'stock_bk',sorter:()=>{}},
  { title: '涨停原因', width: 160, align:'left', dataIndex: 'stock_reason', key: 'stock_reason',sorter:()=>{}, scopedSlots: { customRender: 'stock_bk_name' }},
] 

const columns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '涨停时间',  align:'left', dataIndex: 'stock_zhangting_shijian', key: 'stock_zhangting_shijian',sorter:()=>{}, scopedSlots: { customRender: 'stock_zhangting_shijian' }},
//   { title: 'tm_60',  align:'left', dataIndex: 'tm_60', key: 'tm_60'},
  { title: '名称',  align:'left', dataIndex: 'stock_name', key: 'stock_name',sorter:()=>{}, scopedSlots: { customRender: 'stock_name' }},
  { title: '连板',  align:'left', dataIndex: 'kick_no', key: 'kick_no',sorter:()=>{}},
//   { title: '涨停',  align:'left', dataIndex: 'zt_count', key: 'zt_count',sorter:()=>{}},

//   { title: '换手',  align:'left', dataIndex: 'stock_shiji_huanshou', key: 'stock_shiji_huanshou',sorter:()=>{}},
  { title: '代码',  align:'left', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},

//   { title: 'tm930',  align:'left', dataIndex: 'tm_930', key: 'tm_930',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力封单',  align:'left', dataIndex: 'stock_fengdan', key: 'stock_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title: '最大封单',  align:'left', dataIndex: 'stock_max_fengdan', key: 'stock_max_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title: '股票成交',  align:'left', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title: '净额',  align:'left', dataIndex: 'stock_zhuli_jinge', key: 'stock_zhuli_jinge',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '卖出',  align:'left', dataIndex: 'stock_zhuli_maichu', key: 'stock_zhuli_maichu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '买入',  align:'left', dataIndex: 'stock_zhuli_mairu', key: 'stock_zhuli_mairu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title: '流值',  align:'left', dataIndex: 'stock_zongzhi', key: 'stock_zongzhi',sorter:()=>{}, scopedSlots: { customRender: 'stock_zongzhi' }},
//   { title: '实际', align:'center', dataIndex: 'stock_shiji_liutong', key: 'stock_shiji_liutong', scopedSlots: { customRender: 'price' },sorter:()=>{}}, 
    //   { title: '推送通知', width: 320, align:'left', dataIndex: 'stock_reminder_msg', key: 'stock_reminder_msg',sorter:()=>{}, scopedSlots: { customRender: 'stock_reminder_msg' }},
  { title: '股票板块', width: 280, align:'left', dataIndex: 'stock_bk', key: 'stock_bk',sorter:()=>{}, scopedSlots: { customRender: 'stock_bk' }},
  { title: '板块名称',  align:'left', dataIndex: 'concept_name', key: 'concept_name',sorter:()=>{}, scopedSlots: { customRender: 'concept_name' }},
  { title: '涨停原因', width: 120, align:'left', dataIndex: 'stock_reason', key: 'stock_reason',sorter:()=>{}, scopedSlots: { customRender: 'stock_bk_name' }},
  { title: '操作', width: 60, key: 'operation', scopedSlots: { customRender: 'action' }}
  
//   { title: '5涨幅', width: 80, align:'left', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu',sorter:()=>{}},
//   { title: '5振幅', width: 80, align:'left', dataIndex: 'stock_zhenfu', key: 'stock_zhenfu',sorter:()=>{}},
//   { title: '累计涨停', width: 80, align:'left', dataIndex: 'kick_count', key: 'kick_count',sorter:()=>{}},
//   { title: '股票换手', width: 80, align:'left', dataIndex: 'stock_huanshou', key: 'stock_huanshou',sorter:()=>{}},
//   { title: '市值',  align:'left', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi',sorter:()=>{}}
] 

const columns2 = [
  // { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' },
  { title: '日期', align:'center', dataIndex: 'stock_date', key: 'stock_date'},
  { title: '开盘', align:'center', dataIndex: 'stock_jinkai', key: 'stock_jinkai'},
  { title: '价格', align:'center', dataIndex: 'stock_now', key: 'stock_now'},
  { title: '振幅', align:'center', dataIndex: 'stock_zhenfu', key: 'stock_zhenfu'},
//   { title: '盘口', align:'center', dataIndex: 'stock_pankou', key: 'stock_pankou'},
  { title: '涨幅', align:'left', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu', scopedSlots: { customRender: 'price' }},
  { title: '成交额', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'price' }},
  { title: '净流入',  align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru', scopedSlots: { customRender: 'price' }},
  { title: '流入占比', align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '超大流入', align:'center', dataIndex: 'stock_chaoda_liuru', key: 'stock_chaoda_liuru', scopedSlots: { customRender: 'price' }},
  { title: '超大占比', align:'center', dataIndex: 'stock_chaoda_liuru_zhanbi', key: 'stock_chaoda_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '大流入', align:'center', dataIndex: 'stock_da_liuru', key: 'stock_da_liuru', scopedSlots: { customRender: 'price' }},
  { title: '大占比',  align:'center', dataIndex: 'stock_da_liuru_zhanbi', key: 'stock_da_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '中流入', align:'center', dataIndex: 'stock_zhong_liuru', key: 'stock_zhong_liuru', scopedSlots: { customRender: 'price' }},
  { title: '中占比', align:'center', dataIndex: 'stock_zhong_liuru_zhanbi', key: 'stock_zhong_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '小流入', align:'center', dataIndex: 'stock_xiao_liuru', key: 'stock_xiao_liuru', scopedSlots: { customRender: 'price' }},
  { title: '小占比', align:'center', dataIndex: 'stock_xiao_liuru_zhanbi', key: 'stock_xiao_liuru_zhanbi', scopedSlots: { customRender: 'price' }}

] 

const columns3 = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '名称', width: 80, align:'left', dataIndex: 'stock_name', key: 'stock_name',sorter:()=>{}},
  { title: '代码', width: 80, align:'center', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '涨幅', width: 80, align:'center', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '振幅', width: 80, align:'center', dataIndex: 'stock_zhenfu', key: 'stock_zhenfu',sorter:()=>{}},
//   { title: '价格', width: 80, align:'center', dataIndex: 'stock_now', key: 'stock_now',sorter:()=>{}},
  { title: '换手', width: 80, align:'center', dataIndex: 'stock_huanshou', key: 'stock_huanshou',sorter:()=>{}},
//   { title: '量比', width: 80, align:'center', dataIndex: 'stock_liangbi', key: 'stock_liangbi',sorter:()=>{}},
  { title: '流通', align:'center', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '昨日成交额', align:'center', dataIndex: 'stock_jt_chengjiaoe', key: 'stock_jt_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '今日成交额', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '5M净交额', align:'center', dataIndex: 'stock_sort_chengjiaoe', key: 'stock_sort_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '净流入',  align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},

  { title: '火箭发射',  align:'center', dataIndex: 'rocket_time', key: 'rocket_time', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '大笔买入',  align:'center', dataIndex: 'big_buy', key: 'big_buy', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '大笔卖出',  align:'center', dataIndex: 'big_sell', key: 'big_sell', scopedSlots: { customRender: 'price' },sorter:()=>{}},
//   { title: '净占比', align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '板块', align:'center', dataIndex: 'stock_bk', key: 'stock_bk'},
]


const columns4 = [
  { title: '#', width:'45px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}} ,
  { title: '', align:'center', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '', align:'center', dataIndex: 'stock_name', key: 'stock_name', scopedSlots: { customRender: 'stock_name' }},
  { title: '昨', align:'center', dataIndex: 'stock_yesterday_zhangdiefu', key: 'stock_yesterday_zhangdiefu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: '涨速', align:'center', dataIndex: 'stocck_5zhangsu', key: 'stocck_5zhangsu'},
//   { title: '买', align:'center', dataIndex: 'stock_kick_sale.buy', key: 'stock_kick_sale_b', scopedSlots: { customRender: 'price' }},
//   { title: '卖', align:'center', dataIndex: 'stock_kick_sale.sale', key: 'stock_kick_sale_s', scopedSlots: { customRender: 'price' }},
//   { title: '5日', width: 70, align:'center', dataIndex: 'stock_5day_zhangfu', key: 'stock_5day_zhangfu', scopedSlots: { customRender: 'price' }},
//   { title: '振幅', width: 70, align:'center', dataIndex: 'stock_5day_zhenfu', key: 'stock_5day_zhenfu'},
//   { title: '下', width: 70, align:'center', dataIndex: 'fs_low_minute', key: 'fs_low_minute',sorter:()=>{}, scopedSlots: { customRender: 'fs_low_minute' }},

//   { title: '连续', width: 70, align:'center', dataIndex: 'lxsz_count', key: 'lxsz_count',sorter:()=>{}},
  { title: '涨', align:'center', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu',sorter:()=>{}},
  { title: '收', width: 70, align:'center', dataIndex: 'stock_zhangdiefu_zuixin', key: 'stock_zhangdiefu_zuixin', scopedSlots: { customRender: 'stock_zhangdiefu_zuixin' },sorter:()=>{}},
//   { title: 'ONE', width: 70, align:'center', dataIndex: 'fs_one_total', key: 'fs_one_total',sorter:()=>{}, scopedSlots: { customRender: 'fs_one_total' }},
//   { title: 'ONEM', width: 100, align:'center', dataIndex: 'fs_one_total', key: 'fs_one_total_m',sorter:()=>{}, scopedSlots: { customRender: 'fs_one_total_m' }},
//   { title: 'S', width: 40, align:'center', dataIndex: 'stock_short_count', key: 'stock_short_count',sorter:()=>{}},
//   { title: 'K', width: 40, align:'center', dataIndex: 'stock_kick_count', key: 'stock_kick_count',sorter:()=>{}},

//   { title: '昨比', align:'left', dataIndex: 'yes_liangbi', key: 'yes_liangbi'},
  { title: '五比', align:'left', dataIndex: 'yesterday_liangbi', key: 'yesterday_liangbi'},
//   { title: '昨成', align:'left', dataIndex: 'yesterday_cje', key: 'yesterday_cje',scopedSlots: { customRender: 'price' }},
  { title: 'ONE',align:'left', dataIndex: 'one_bili', key: 'one_bili'},
  { title: 'TWO',align:'left', dataIndex: 'two_bili', key: 'two_bili'},
  { title: '今比', width: 70, align:'center', dataIndex: 'stock_liangbi', key: 'stock_liangbi',sorter:()=>{}},
  { title: '昨比', width: 70, align:'center', dataIndex: 'stock_cje_bili', key: 'stock_cje_bili',sorter:()=>{}},
  { title: '今成', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'stock_chengjiaoe' },sorter:()=>{}},
  { title: '昨换', align:'center', dataIndex: 'stock_yesterday_huanshou', key: 'stock_yesterday_huanshou',sorter:()=>{}},
//   { title: '昨流', align:'center', dataIndex: 'stock_yesterday_liuru', key: 'stock_yesterday_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
//   { title: '流入', align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
//   { title: 'Gap', align:'center', dataIndex: 'stock_gap_liuru', key: 'stock_gap_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},

  { title:'931',  align:'left', dataIndex: 'stock_precent', key: 'stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'932',  align:'left', dataIndex: 'two_stock_precent', key: 'two_stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'1GP',  align:'left', dataIndex: 'stock_gap_precent', key: 'stock_gap_precent', scopedSlots: { customRender: 'price' }},
  { title:'2GP',  align:'left', dataIndex: 'two_stock_gap_precent', key: 'two_stock_gap_precent', scopedSlots: { customRender: 'price' }},

//   { title: 'OPT',  align:'left', dataIndex: 'fs_one_opt', key: 'fs_one_opt',sorter:()=>{}, scopedSlots: { customRender: 'opt' }},
  { title: '流通', align:'center', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi', scopedSlots: { customRender: 'stock_zongzhi' },sorter:()=>{}}, 
//   { title: '实际', align:'center', dataIndex: 'stock_shiji_liutong', key: 'stock_shiji_liutong', scopedSlots: { customRender: 'price' },sorter:()=>{}}, 
//   { title: '流值',  align:'left', dataIndex: 'stock_zongzhi', key: 'stock_zongzhi',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
//   { title: 'rsi6', align:'center', dataIndex: 'stock_rsi6', key: 'stock_rsi6',sorter:()=>{}},
//   { title: 'cha', align:'center', dataIndex: 'stock_rsi6_cha', key: 'stock_rsi6_cha',sorter:()=>{}},
//   { title: 'rsi6', align:'center', dataIndex: 'stock_rsi6', key: 'stock_rsi6',sorter:()=>{}},
//   { title: 'zuixin', align:'center', dataIndex: 'stock_cha_zuixin', key: 'stock_cha_zuixin',sorter:()=>{}},
  { title: 'stock_kick', align:'center', dataIndex: 'stock_kick_time', key: 'stock_kick_time',sorter:()=>{}},
  // { title: 'stock_updatetime', align:'center', dataIndex: 'stock_updatetime', key: 'stock_updatetime'},
]
import editModal from './editModal'
import ranges from "@/common/mixins/ranges"
import moment from 'moment'
import tableMixins from '@/common/mixins/table'
export default {
    name:'monitor',
    mixins: [ tableMixins , ranges],
    data() {
        this.chartSettings = {
        xAxisType: ['KMB', 'percent'],
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideStartTop'
          }
      },
      this.tooltip = {
          show:true,  
          trigger: "axis",
          alwaysShowContent:true,
          formatter: function(params) { 
            var res;
            return res;
          }
        },
      this.chartStockSettings = {
        yAxis:{
          show:false,
        },
        grid: {
          containLabel: true,
        },
        showDataZoom: false,
        start: 0,
        end: 100,
        showMA: false,
        MA: [5,10],
        legendName: {}, 
        showVol: false,
        upColor: '#FF8787',
        downColor: '#7FB77E',
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideEndTop'
          }
      },
      this.toolbox = {
          feature: {
          magicType: {},
          saveAsImage: {pixelRatio:2}
          }
      }
        return {
            first:0,
            concept:false,
            loading: false,
            dlLoading:false,
            dVisible: false,
            drvisible:false,
            record:{},
            stock_detail:{},
            fsVisible:false,
            kickLoading:false,
            kickVisible:false,
            start_date:'',
            fs_list:[],
            detail_list:[],
            liuruChart:[],
            liuruList:[],
            fs_list_chart:{},
            kick_list:[],
            kick_his_list:[],
            kickChart:[],
            end_date:'',
            stock_title:'',
            columns,
            columns2,
            ztcolumns,
            columns3,
            columns4,
            sort_list:{
                "2": 925,
                "3": 930,
                "4": 935,
                "5": 940,
                "6": 945,
                "7": 950,
                "8": 955,
                "9": 1000,
                "10": 1005,
                "11": 1010,
                "12": 1015,
                "13": 1020,
                "14": 1025,
                "15": 1030,
                "16": 1035,
                "17": 1040,
                "18": 1045,
                "19": 1050,
                "20": 1055,
                "21": 1100,
                "22": 1105,
                "23": 1110,
                "24": 1115,
                "25": 1120,
                "26": 1125,
                "27": 1130,
                "28": 1135,
                "29": 1300,
                "30": 1305,
                "31": 1310,
                "32": 1315,
                "33": 1320,
                "34": 1325,
                "35": 1330,
                "36": 1335,
                "37": 1340,
                "38": 1345,
                "39": 1350,
                "40": 1355,
                "41": 1400,
                "42": 1405,
                "43": 1410,
                "44": 1415,
                "45": 1420,
                "46": 1425,
                "47": 1430,
                "48": 1435,
                "49": 1440,
                "50": 1445,
                "51": 1450,
                "52": 1455,
                "53": 1500,
                "54": 1505
                },
            paramsData:{
                "page": 1,
                "per-page": 10,
                "search": {
                    shsz:'',
                    stock_zhangting_type:''
                },
                "sort": '',
                filter_type:'day',
                start_date:'',
                end_date:'',
            },
            pageParams: {
                currentPage: 1,
                pageCount: 50,
                perPage: 10,
                totalCount: 0,
            },
            searchData: {
                shsz:'sz',
                keyword:'',
                bk_date:'',
                bk_stock_type:'',
                bk_sort:'',
                bk_mode:'kick'
            },
            modalData:{},
            editVisible : false,
            list:[],
            kick_resason_list:[],
            yesterday_kick_resason_list:[],
            appList:[],
            histogramChartExtend:{
            series(item){
                console.log(item)
                    if(item){
                        item[0].barMaxWidth = 10;
                        item[0].color = '#23d9ae';
                        // item[0].barMaxWidth = 10
                        // item[0].itemStyle = Object.assign({}, {
                        //     normal:{
                        //         color: function(params) {
                        //             return {
                        //                 type: 'linear',
                        //                 x:1,
                        //                 y:1,
                        //                 x2:0,
                        //                 y2:0,
                        //                 colorStops: [{
                        //                     offset: 0,
                        //                     color: '#ffffff'
                                            
                        //                 }, {
                        //                     offset: 1,                    
                        //                     color: '#23d9ae'
                        //                 }],
                        //             }
                        //         },
                        //         barBorderRadius:[30,30,0,0]
                        //     }
                        // })
                        if(item[1]){
                            item[1].color='red'
                            // item[1].itemStyle = Object.assign({}, {
                            //     normal:{
                            //         color: function(params) {
                            //             return {
                            //                 type: 'linear',
                            //                 x:1,
                            //                 y:1,
                            //                 x2:0,
                            //                 y2:0,
                            //                 colorStops: [{
                            //                     offset: 0,
                            //                     color: 'red'
                                                
                            //                 }, {
                            //                     offset: 1,                    
                            //                     color: '#23d9ae'
                            //                 }],
                            //             }
                            //         },
                            //         barBorderRadius:[30,30,0,0]
                            //     }
                            // })
                        }
                        if(item[3]){
                            item[3].color='#FF6600'
                        }
                    }
                    return item
                },
                xAxis:{
                    axisLine:{
                        show:true,
                        lineStyle: {
                            type: 'dotted',
                        }
                    },
                },
                yAxis(item){
                    item[0].axisLine = Object.assign({}, {
                        show:false
                    })
                    item[0].splitLine = Object.assign({}, {
                        show:true,
                        lineStyle: {
                            type: 'dotted'
                        }
                    })
                    return item
                },
            },
            pie:{},
            stockCode:'',
            predictMsg:[],
            stock_detail:{},
            stockChartData:[],
            dailyChart:[],
            predictChart:[],
            rsiChart:[],
            predictLiuruChart:[],
            loadingP:false,
            articles_list:[],
            liuruChart:[],
            liuruList:[],
        }
    },
    components: {
        editModal,
    },
    created () {
        this.paramsData.search.start_date = moment().subtract('days',0).format('YYYY-MM-DD')
        this.paramsData.search.end_date = moment().subtract('days',0).format('YYYY-MM-DD')
        this.paramsData.start_date = this.paramsData.search.start_date
        this.paramsData.end_date = this.paramsData.search.end_date
        this.rangesValue = [moment(this.paramsData.search.start_date,'YYYY-MM-DD'),moment(this.paramsData.search.end_date,'YYYY-MM-DD')]
        // this.getApp()
    },
    methods: {
        disabledDate(current) {
             // 注意：current 是当前遍历到的日期，类型为Day.js对象
            const day = current.day(); // 获取星期几，0为周日，6为周六
            return day === 0 || day === 6;
        },
        onClose(){
            this.drvisible = false;
        },
        async clk_buy(stock_code,stock_name){
            let that = this;
            this.$confirm({
                title: 'Are you sure '+stock_name+'?',
                content: '',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                    that.loading = true
                    let res = that.$store.dispatch('enterpriseLabStockMbuyAction', {data:{stock_code:stock_code}})
                    that.loading = false
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        async clk_concept(concept_code,item){
            this.dVisible = true;
            this.dlLoading = true;
            this.concept = item
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.paramsData.start_date
            obj['end_date'] = this.paramsData.end_date
            obj['keyword']=item.concept_name;
            this.searchParams.search = obj
            this.searchParams.code = concept_code
            this.searchData.keyword = item.concept_name;
            console.log(this.searchData)
            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
        },
        async addStock(record){
            console.log(record)
            let bk_name = this.concept?this.concept.concept_name:this.record.stock_reason;
            let res = await this.$store.dispatch('enterpriseLabStockAddStockAction', { data: {search:{stock_code:record.stock_code,bk_name:bk_name}} })
            this.$message.success('添加成功');
        },
        async getDetail(record,keyword,add) {
            this.searchData.keyword = keyword;
            this.dVisible = true;
            this.record = record;
            this.dlLoading = true;
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.paramsData.start_date
            obj['end_date'] = this.paramsData.end_date

            if(add){
                obj['add'] = add;
            }  
            this.searchParams.search = obj
            if(this.concept){
              this.searchParams.code = this.concept.concept_code
            }else{
                this.searchParams.code = record.concept_code
            }
            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
        },
        zuixincolor(value,target){
            if(Number(value) < Number(target)){
            return {color:'green'};
            }
            if(value==0){
            return '';
            }
            if(Number(value) > Number(target)){
            return {color:'red'};
            }
        },
        handleButTypeChange(e){
            this.searchData.bk_stock_type = e.target.value
            this.getDetail(this.record,this.searchData.keyword)
        },
        handleButDateChange(e){
            this.searchData.bk_date = e.target.value
            this.getDetail(this.record,this.searchData.keyword)
        },
        handleModalButChange(e){
            this.searchData.shsz = e.target.value
            this.getDetail(this.record,this.searchData.keyword)
        },
        handleButAddChange(){
            this.getDetail(this.record,this.searchData.keyword,'1')
        },
        handleButZtChange(e){
            this.searchData.zt_filter = e.target.value
            this.getList()
        },
        handleButRsiChange(e){
            if(e == this.searchData.rsi){
            this.searchData.rsi = 0;
            }else{
            this.searchData.rsi = e
            }
            this.getDetail(this.record,this.searchData.keyword)
        },
        handleButM5Change(e){
            if(e == this.searchData.m5){
            this.searchData.m5 = 0;
            }else{
            this.searchData.m5 = e
            }
            this.getDetail(this.record,this.searchData.keyword)
        },
        viewConcept(record){
            this.record = record
            this.concept = true;
            this.searchData.bk_sort = record.bk_sort;
            this.drvisible = true;
            this.stock_detail = record;
        },
        view(record){
            this.concept = false;
            this.record = record
            this.searchData.bk_sort = record.bk_sort;
            this.getDetail(record,record.stock_reason)
        },
        handleButChange(e){
            if(this.paramsData.search.shsz == e){
                this.paramsData.search.shsz = ''
            }else{
                this.paramsData.search.shsz = e
            }
            this.getList()
        },
        handleBut2Change(e){
            if(this.paramsData.search.stock_zhangting_type == e){
                this.paramsData.search.stock_zhangting_type = ''
            }else{
                this.paramsData.search.stock_zhangting_type = e
            }
            this.getList()
        },
        clkzt(stock_reason){
            this.paramsData.search.stock_reason = stock_reason;
            this.getList();
        },
        handleSort(e){
            this.searchData.bk_sort = e.target.value;
            this.getDetail(this.record,this.record.stock_reason)
        },
        onFsChange(date, dateString) {
            this.paramsData.search.stock_date = dateString
            this.getPredictChart(this.stockCode);
        },
        clkFs(data){
            this.fsVisible = true;
            this.fs_list = data.sub_fs;
        },
        color(value){
          if(value < 0){
            return {color:'green'};
          }
          if(value==0){
            return '';
          }
          if(value > 0){
            return {color:'red'};
          }
        },
        formatNumber(value) {
          let flag = '';
          if(value<0){
            value=Math.abs(value)
            flag = '-';
          }
          if (value >= 100000000) {
            return flag+(value / 100000000).toFixed(2) + ' 亿';
          } else if (value >= 10000) {
            return flag+(value / 10000).toFixed(2) + ' 万';
          } else if (value >= 1000) {
            return flag+(value / 1000).toFixed(2) + ' 千';
          } else {
            return flag+value;
          }
        },
        async handleOk() {
            //window.open("https://quote.eastmoney.com/"+this.stockCode+".html");
           this.getPredictChart(this.stockCode)  
        },
        clktime(stock_code,stock_detail){
          this.kickVisible = true;
          this.stockCode = stock_code;
          this.stock_detail = stock_detail;
          this.paramsData.search.stock_date = '';
          //console.log(stock_code)
          this.getKickTree(stock_code)
        },
        clk(stock_code,stock_detail){
          this.stockCode = stock_code;
          this.stock_detail = stock_detail;
          this.paramsData.search.stock_date = '';
          //console.log(stock_code)
          this.getPredictChart(stock_code)
        },
        async getKickTree(stock_code) {
              this.kickLoading = true;
              let res = await this.$store.dispatch('enterpriseLabStockKickTreeAction', {data:{search:{stock_code:stock_code},'per-page': 50}})
              this.kick_list = res.items
              this.pageParams = res._meta
              this.kickLoading = false;
              
        },
        async getPredictChart(stock_code) {
              this.editVisible = true;
              this.loadingP = true;
              let res = await this.$store.dispatch('enterpriseLabLiuruAction', {data:{search:{stock_name:stock_code,stock_date:this.paramsData.start_date},'type':'kick'}})
              this.predictChart = res.data.predict_chart
              this.predictLiuruChart = res.data.predict_liuru_chart
              this.articles_list = res.data.articles_list;
              this.pie = res.data.pie
              this.kick_his_list = res.data.kick_his_list
              this.predictMsg = res.data.fs_list
              this.rsiChart = res.data.rsi_chart
              this.stock_title =  this.stock_detail.stock_name + ' ' + res.data.pie_title
              this.fs_list_chart = res.data.sub_fs_chart;
            //   this.predictMsg = res.data.short_msg
              this.liuruList = res.data.liuru_list
              this.loadingP = false
        },
        onCopy(){
                this.$message.success('已复制到剪切板!')
        },
        onError(){
            this.$message.error('操作失败!')
        },
        showDelModal(item) {
            let res = this.$store.dispatch('enterpriseFiscalDelAction',{data:{fisca_id:item.id}})
            this.getList();
        },
        showEditModal(item) {
            this.modalData = item
            this.editVisible = true
        },
        hideEditModal(type) {
            if (type === 1) {
                this.getList()
            }
            this.editVisible = false
        },
        async getList() {
            this.loading = true
            let res = await this.$store.dispatch('enterpriseLabStockRelayAction', {data:this.paramsData})
            this.list = res.items
            this.kick_resason_list = res.kick_list
            this.kickChart = res.kick_chart
            this.yesterday_kick_resason_list = res.yesterday_kick_list
            this.pageParams = res._meta
            this.loading = false
        },
        async getApp(val){
            await this.$store.dispatch('enterpriseFilterAppAction', {data:{app_name:val}})
            .then((res)=>{
                this.appList = res.data
            })
        },
        toScreen(){
            this.getList();
        },
        handleSearchApp(val){
            this.getApp(val)
        },
        // handleButChange(e){
        //     this.paramsData.search.stock_status = e.target.value
        //     this.getList()
        // },
        handleChange(pagination, filters, sorter){
            if(sorter.order){
                if(sorter.order === "ascend"){
                    this.paramsData['sort'] = `${sorter.field}`
                }else{
                    this.paramsData['sort'] = `-${sorter.field}`
                }
                }else{
                this.paramsData['sort'] = ''
                }
            this.getList()
        },
        handleChange2(pagination, filters, sorter){
            if(sorter.order){
                if(sorter.order === "ascend"){
                    this.searchParams['sort'] = `${sorter.column.key}`
                }else{
                    this.searchParams['sort'] = `-${sorter.column.key}`
                }
                }else{
                this.searchParams['sort'] = ''
            }
            this.getDetail(this.record,this.searchData.keyword)
        },
    },
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}
.ant-modal-body .ant-row{
    margin: 10px 20px !important;
}
</style>